import React from 'react';
import withRouteHelpers from 'common/hoc/withRouteHelpers';
import ProjectTemplateAutoAssignmentRuleSelect from './ProjectTemplateAutoAssignmentRuleSelect';
import useUnions from './hooks/useUnions';

const ProjectTemplateAutoAssignmentRuleUnionSelect = props => {
  const {
    className,
    'data-test-id': dataTestId,
    onChange,
    projectId,
    unionCode,
  } = props;
  const { data: unions, loading } = useUnions({ projectId });
  const unionOptions = unions?.map(({ code, description }) => ({
    label: description,
    value: code,
  }));
  return (
    <ProjectTemplateAutoAssignmentRuleSelect
      label="Union"
      isLoading={loading}
      options={unionOptions}
      value={unionCode}
      onChange={unionCode =>
        onChange(unions.find(({ code }) => code === unionCode))
      }
      data-test-id={dataTestId}
      className={className}
    />
  );
};

export default withRouteHelpers(ProjectTemplateAutoAssignmentRuleUnionSelect);
